export default __webpack_public_path__ + "static/media/japan.6f871685.png";